import PropTypes from 'prop-types'
import { Checkbox as MuiCheckbox, FormControlLabel } from '@mui/material'

import SwitchLabel from '../switchLabel'

import useStyles from './styles'

const Checkbox = ({ label, subLabel, disabled, indeterminate, error, ...other }) => {
  const classes = useStyles()
  return (
    <FormControlLabel
      label={
        <SwitchLabel label={label} subLabel={subLabel} disabled={disabled} />
      }
      control={<MuiCheckbox indeterminate={indeterminate} />}
      disabled={disabled}
      {...other}
      className={error ? classes.formControlLabelError : classes.formControlLabel}
    />
  )
}

Checkbox.propTypes = {
  label: PropTypes.string,
  subLabel: PropTypes.string,
  indeterminate: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool
}

export default Checkbox
